export default __webpack_public_path__ + "static/mobile-big-2x-ac8f4f69c07601224144893cfd113bc5.jpeg";